/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class WidgetsParser {

    static parse(cfg) {
        if (!cfg.widgets) {
            cfg.widgets = {
                enabled: false,
                enablePanel: false,
                panel: {
                    base: `${cfg.game.preconfig.cdn}../../widgets/panel/`,
                    main: 'app.min.js',
                },
                tournaments: {
                    base: `${cfg.game.preconfig.cdn}../../widgets/tournaments/`,
                    assets: 'assets/',
                    main: 'app.min.js',
                    leaderboardUrl: `${cfg.bridge.feedUrl}/tournaments/leaderboard/`,
                },
                view: {
                    backgroundColor: 0x004D94
                },
                splash: {
                    assets: 'assets/',
                    lang: 'en',
                    waitTime: 0,
                },
                timestamp: cfg.bridge.timestamp
            };

        }

        if (!cfg.widgets.timestamp) {
            cfg.widgets.timestamp = cfg.bridge.timestamp;
        }

        // TODO :: check launcher
        if (cfg.widgets && cfg.widgets.portrait && cfg.widgets.portrait.topBarHeight) {
            cfg.widgets.portrait.topBarHeight = 41;
        }

        if (!cfg.bridge.inReview) { // TODO :: unify inReview
            // Disable widgets by default and enable it only on a spec widget activation
            cfg.widgets.enabled = false;
        }


        return cfg.widgets;
    }

}


module.exports = WidgetsParser;
